<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
</script>

<template>
  <div :class="twMerge('flex items-center gap-1.5', String($props.class || ''))">
    <slot name="grid">
      <!-- Intended to be passed a FileTableRowGrid component -->
    </slot>
  </div>
</template>
